import React, { memo } from 'react';
import { NodeProps } from 'reactflow';
import { Activity, User, Target, FileText, TestTube, Calculator } from 'lucide-react';
import WhatsAppStyleNode from './WhatsAppStyleNode';
import { AnalyticsNodeData } from '../../types/nodes';

const analyticsIcons = {
  track_event: <Activity />,
  user_profile: <User />,
  conversion: <Target />,
  report_generator: <FileText />,
  ab_test: <TestTube />,
  metrics_calculator: <Calculator />
};

const analyticsLabels = {
  track_event: 'Traccia Evento',
  user_profile: 'Profilo Utente',
  conversion: 'Conversione',
  report_generator: 'Genera Report',
  ab_test: 'Test A/B',
  metrics_calculator: 'Calcola Metriche'
};

const AnalyticsNode: React.FC<NodeProps<AnalyticsNodeData>> = memo(({ selected, data }) => {
  const icon = analyticsIcons[data.analyticsType] || <Activity />;
  const label = analyticsLabels[data.analyticsType] || 'Analytics';
  
  const getPreview = () => {
    switch (data.analyticsType) {
      case 'track_event':
        return data.config.eventName || 'Evento generico';
      case 'user_profile':
        return 'Aggiorna profilo';
      case 'conversion':
        return data.config.conversionGoal || 'Obiettivo';
      case 'report_generator':
        return data.config.reportType || 'Report completo';
      case 'ab_test':
        return data.config.testVariant || 'Variante A';
      case 'metrics_calculator':
        return data.config.metricType || 'Metrica custom';
      default:
        return null;
    }
  };

  return (
    <WhatsAppStyleNode
      selected={selected}
      icon={icon}
      label={label}
      preview={getPreview()}
      color="from-rose-500 to-pink-600"
      handles={{
        target: true,
        source: true,
      }}
    />
  );
});

AnalyticsNode.displayName = 'AnalyticsNode';

export default AnalyticsNode;
